import styled from 'styled-components';

import { ArticleCaptionAndCredits } from 'editorial/components/ArticleCaptionAndCredits';
import { ArticleProductMarker } from 'editorial/components/ArticleProductMarker';
import { breakpoints } from 'styles/theme/breakpoints';
import { IArticlePicture } from 'editorial/types';
import { Image } from 'shared/components/Image';
import { normalizeValue } from 'shared/utils/normalizeValue';

interface IArticleImage {
  caption: string;
  credits: string;
  picture: IArticlePicture;
  sizes?: string;
}

export const ArticleImage = ({
  caption,
  credits,
  picture: { imageFileName, url: src, productMarkers },
  sizes,
}: IArticleImage) => {
  return (
    <ArticleImage.Wrapper>
      {productMarkers &&
        productMarkers.map((marker) => {
          return <ArticleProductMarker key={marker.id} marker={marker} openInNewWindow />;
        })}
      <Image
        alt={normalizeValue(imageFileName)}
        data-qa="article_image_component"
        noSrcModification={src?.toLowerCase()?.includes('.gif')}
        src={src}
        sizes={sizes || `(max-width: ${breakpoints.medium}px) 90vw, 60vw`}
      />
      <ArticleCaptionAndCredits caption={caption} credits={credits} />
    </ArticleImage.Wrapper>
  );
};

ArticleImage.Wrapper = styled.div`
  position: relative;
`;
